import ModalOrderItemDetail from './ModalOrderItemDetail'

const ModalOriginalOrder = ({ isOpen, toggle, transaction }) => {
  return (
    <ModalOrderItemDetail
      isOpen={isOpen}
      toggle={toggle}
      transaction={transaction}
      type="order"
    />
  )
}

export default ModalOriginalOrder
